import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class SecureItemService extends ApiService {
  namespace = "secure-item";
  icon = "Shield";
  name = "Secure";
  favicon = "ReceiptsWithArrow";
  actionTitle = "Secure Item";
  window = 290;
  Width = 790;
  DOMAIN = DOMAIN.SECURE_ITEM;
  singular = this.terminology.method.singular;
  plural = this.terminology.method.plural;
  vowel = this.terminology.method.vowel;
  action = "action";
  singular = this.terminology.method.singular;
  plural = this.terminology.method.plural;
  vowel = this.terminology.method.vowel;

  copySelector = [
    {
      key: DOMAIN.INVOICE,
      label: "Invoice",
    },
    {
      key: DOMAIN.ESTIMATE,
      label: "Estimates",
    },
    {
      key: DOMAIN.SALES_RECEIPTS,
      label: "Sales reciept",
    },
    {
      key: DOMAIN.CREDIT_MEMO,
      label: "Credit Memos",
    },
  ];
  constructor() {
    super("ar-delivery-methods");
  }
}
